import { PhosphorDownloadSimpleButton } from "components/Atoms/PhosphorIconButton";
import { InPageEditableStandaloneField } from "components/MainSectionTemplate/InPageEditableStandaloneField";
import RequiredTextInput from "components/ValidatedFields/RequiredTextInput";
import React from "react";
import ESignFileSourceInfo from "./ESignFileSourceInfo";

interface Props {
  file: server.dto.ESignFile
  onSave: (newFileName: string, eSignFileId: number) => void
}

const File = (props: Props) => {
  const { file } = props;

  return <>
    <div className="grow1">
      <InPageEditableStandaloneField
        value={file.name}
        onValueUpdated={newVal => {
          props.onSave(newVal, file.eSignFileId);
        }}
        render={() => <span>{file.fullName}</span>}
        renderEdit={({ value, onChange, submit, cancel }) => <RequiredTextInput
          focusOnMount
          value={value}
          maxLength={serverReference.constants.file.maxNameLength}
          rightComponent={{ position: "right", type: "text", label: `.${props.file.extension}` }}
          onChange={onChange}
          onEnter={submit}
          onEsc={cancel}
          validatorKey="fileName"
        />}
      />
      <ESignFileSourceInfo file={file} />
    </div>
    <div>
      {file.contentLengthText}
    </div>
    <div>
      <PhosphorDownloadSimpleButton
        onClick={() => {
          window.location.href = file.downloadUrl + "?requestSource=adminPage";
        }}
        layout="in-square"
      />
    </div>
  </>;
};

export default File;